<template>
  <div class="character" v-if="characterList">
    <div class="character__select">
      <div
        v-for="(item, index) of characterList"
        :key="item.caseId"
        :class="['character__option', index === current ? 'active' : '']"
        @click="onChange(index)"
      >
        <div class="character__option__box">
          <div class="character__option__name">{{item.name}}</div>
          <img class="character__option__img" :src="item.imgHVUrl" />
        </div>
      </div>
    </div>
    <div class="character__content">
      <div class="character__img">
        <img :src="characterList.length > 1 && characterList[current].ottImgUrl" />
      </div>
      <div class="character__info">
        <div class="character__name">{{characterList.length > 1 && characterList[current].name}}</div>
        <div class="character__desc">{{characterList.length > 1 && characterList[current].subName}}</div>
        <!-- <ul class="character__attr">
          <li>优点</li>
          <li>缺点</li>
        </ul> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'character',
  props: {
    characterList: {
      type: Array,
      default: () => {
        return [{
          ottImgUrl: ''
        }]
      }
    }
  },
  data () {
    return {
      current: 0
    }
  },
  methods: {
    onChange: function (id) {
      this.current = id
    }
  }
}
</script>

<style>
.character {
  box-sizing: border-box;
  background-color: #FFF;
  margin-bottom: 80px;
}
.character__select {
  height: 138px;
}
.character__option {
  float: left;
  height: 76px;
  width: 264px;
  margin-top: 40px;
  margin-left: 30px;
  cursor: pointer;
}
.character__option__box {
  height: 64px;
  line-height: 64px;
  width: 264px;
  border-radius: 32px;
  background: #E4F6FD;
  position: relative;
}
.character__option__name {
  margin-left: 25px;
  font-size: 18px;
  height: 64px;
  color: rgba(102, 153, 166, .8)
}
.character__option__img {
  width: 112px;
  height: 154px;
  position: absolute;
  bottom: -33px;
  right: 0;
}
.character__option.active {
  background: url("./images/character-select.png")no-repeat;
}
.character__option.active .character__option__box  {
  background: none;
}
.character__option.active .character__option__name  {
  color: #FFF;
}

.character__content {
  align-items: center;
  height: 328px;
  padding: 40px;
  box-sizing: border-box;
  background-size: 100%;
}
.character__img {
  width: 214px;
  height: 240px;
  margin-right: 20px;
  float: left;
}
.character__img img {
  width: 214px;
  height: 240px;
}
.character__info {
  /* display: flex;
  flex-direction: column;
  align-items: flex-start; */
  height: 100%;
  width: 880px;
  float: left;
}
.character__name {
  font-size: 30px;
  color: #232222;
  margin-top: 43px;
}
.character__desc {
  font-size: 14px;
  color: #676767;
  line-height: 21px;
  margin-top: 28px;
}
.character__attr {
  margin-top: 35px;
  padding-left: 25px;
  color: #676767;
}
</style>



// WEBPACK FOOTER //
// src/components/character.vue